import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
    query FilmPage($id: ID!, $masterLimit: Int) {
        FilmPage: Film(id: $id) {
        ...filmBigAwards
        ...filmBigDetail
        ...filmMasters
        ...filmPeople
        ...filmBrands
        ...filmProducts
        ...filmCompanies
      }
    }
    ${fragments.filmRelationships}
    ${fragments.relationshipTypeDetail}
    ${fragments.filmPeople}
    ${fragments.filmBigDetail}
    ${fragments.artworkToArtifacts}
    ${fragments.artworkDetails}
    ${fragments.filmDetail}
    ${fragments.filmMasters}
    ${fragments.filmMasterDetail}
    ${fragments.stripDetail}
    ${fragments.filmHost}
    ${fragments.filmMasterPosterFrames}
    ${fragments.stripDetail}
    ${fragments.filmFiles}
    ${fragments.filmFileDetail}
    ${fragments.personDetail}
    ${fragments.personArtworks}
    ${fragments.profession}
    ${fragments.companyDepartmentDetail}
    ${fragments.commissionType}
    ${fragments.critiqueRating}
    ${fragments.locationTree}
    ${fragments.location}
    ${fragments.filmLocation}
    ${fragments.operationRegion}
    ${fragments.filmBrands}
    ${fragments.brandDetail}
    ${fragments.brandArtworks}
    ${fragments.filmProducts}
    ${fragments.productDetail}
    ${fragments.productArtworks}
    ${fragments.productCategory}
    ${fragments.productCategoryTree}
    ${fragments.companyArtworks}
    ${fragments.companyNames}
    ${fragments.companyType}
    ${fragments.companyTypeTree}
    ${fragments.companyType}
    ${fragments.companyNameDetail}
    ${fragments.companyDetail}
    ${fragments.filmCompanies}
    ${fragments.filmBigAwards}
    ${fragments.awardPrizeArtworks}
    ${fragments.awardPrizeDetail}
    ${fragments.awardAncestor}
    ${fragments.personBigAwards}
  `
